import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";
import {
  shade0,
  shade300,
  shade700,
  shade800,
} from "../../../../styles/tokens";

// TEXT

// STYLES
export const DiscreteInputBase = styled.input.attrs(
  ({ type = "number", ...rest }) => ({
    ...rest,
    type,
  }),
)<{ $expectedLength?: number }>`
  line-height: 2rem;
  width: 4rem;
  height: 2rem;
  text-align: center;
  appearance: textfield;

  background: transparent;
  border: 1px solid ${shade800};
  border-radius: 4rem;
  color: ${shade0};
  font-family: inherit;
  outline: none;

  &::placeholder {
    color: ${shade300};
  }

  &:focus {
    border-color: ${shade0};
  }

  &:disabled {
    color: ${shade700};
    cursor: not-allowed;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    display: none;
  }
`;

// DATA

// TYPES
export interface Props extends Omit<ComponentPropsWithoutRef<"input">, "size"> {
  expectedLength: number;
  value: number;
  normalize?: (value: number) => number;
  setValue?: (next: number) => void;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
